import React from 'react';
import { motion } from 'framer-motion';

interface MotionSectionProps {
  id?: string;
  children: React.ReactNode;
  className?: string;
  muted?: boolean;
}

const MotionSection: React.FC<MotionSectionProps> = ({
  id,
  children,
  className = '',
  muted = false,
}) => {
  return (
    <section
      id={id}
      className={`section-container ${muted ? 'section-container--muted' : ''} ${className}`}
    >
      <motion.div
        initial={{ opacity: 0, y: 24, filter: 'blur(4px)' }}
        whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.div>
    </section>
  );
};

export default MotionSection;
